import React, { Component } from 'react';

import './style.css';

export default class RadioButton extends Component {
  render() {
    return (
      <div className={this.props.classStyle}>
        <input
          id={this.props.inputId} className='radio__button'
          type='radio' name={this.props.name} hidden={true}
          onChange={this.props.onChangeCallback}
          defaultChecked={this.props.checked} ref='radiobutton'
        />
        <label
          htmlFor={this.props.inputId}
          className={'radio__label'}
        >
          {this.props.title}
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/radio-button/RadioButton.js